import React from 'react';
import ItemList from '@/components/ItemList';

const ItemsPage: React.FC = () => {
  return <ItemList />;
};

export default ItemsPage;
